import * as moment from 'moment'
import * as React from 'react'
import { postService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import injectGoogleMaps from '../../../../utils/injectGoogleMaps'
import { PostDetail } from 'components/organisms/Posts/Show/PostDetail'

interface IProps {
  editable: boolean
  google: any
  isOwner: boolean
  isSignedIn: boolean
  post_owner: interfaces.IUser
  post: any
  related_posts: any
  reviews: any
  user: interfaces.IUser
  identification_required: boolean
  profile_required: boolean
  cancel_policy: string
  member_posts: any
  highlighted_reviews: any
}

export const PostShow: React.FC<IProps> = props => {
  const { post } = postService.getPostFromJson(props.post)
  const { data: member_posts } = postService.getDataFromJson(props.member_posts)
  Hooks.SetDocumentTitle(post.name)
  const [totalPrice, setTotalPrice] = React.useState(null)
  const [selectedDate, setSelectedDate] = React.useState<moment.Moment | null>(moment())
  const initReviews = postService.getDataFromJson(props.reviews)
  const highlightedReviews = postService.getDataFromJson(props.highlighted_reviews).data
  return (
    <PostDetail
      {...props}
      post={post}
      reviews={initReviews}
      totalPrice={totalPrice}
      setTotalPrice={setTotalPrice}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      user={props.user}
      member_posts={member_posts}
      highlightedReviews={highlightedReviews}
    />
  )
}
export default injectGoogleMaps(PostShow)
